/** English transcript helpers for the STT lab only. */

export function normalizeSpoken(text) {
  return String(text || '').replace(/\s+/g, ' ').trim();
}

export function foldSpoken(text) {
  return normalizeSpoken(text)
    .toLowerCase()
    .replace(/[''`´]/g, '')
    .replace(/[.,!?":;()[\]]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function coversSpoken(haystack, needle) {
  const h = foldSpoken(haystack);
  const n = foldSpoken(needle);
  if (!n) return true;
  if (!h) return false;
  if (h === n || h.includes(n)) return true;
  const hw = h.split(' ').filter(Boolean);
  const nw = n.split(' ').filter(Boolean);
  if (!nw.length) return true;
  if (nw.length === 1) return hw.slice(-16).includes(nw[0]);
  if (nw.length > hw.length) return false;
  for (let i = 0; i <= hw.length - nw.length; i += 1) {
    if (hw.slice(i, i + nw.length).join(' ') === nw.join(' ')) return true;
  }
  return hw.slice(-nw.length).join(' ') === nw.join(' ');
}

export function appendTranscript(base, next) {
  const a = normalizeSpoken(base);
  const b = normalizeSpoken(next);
  if (!b) return a;
  if (!a) return b;
  if (coversSpoken(a, b)) return a;
  if (coversSpoken(b, a) && foldSpoken(b).length >= foldSpoken(a).length) return b;
  const aWords = foldSpoken(a).split(' ').filter(Boolean);
  const bWords = foldSpoken(b).split(' ').filter(Boolean);
  const origB = b.split(' ').filter(Boolean);
  const max = Math.min(aWords.length, bWords.length, 32);
  for (let n = max; n >= 2; n -= 1) {
    if (aWords.slice(-n).join(' ') === bWords.slice(0, n).join(' ')) {
      const extra = origB.slice(n).join(' ');
      return extra ? `${a} ${extra}` : a;
    }
  }
  if (aWords[aWords.length - 1] === bWords[0]) {
    const extra = origB.slice(1).join(' ');
    return extra ? `${a} ${extra}` : a;
  }
  return `${a} ${b}`;
}

export function pickOfficial(browser, server) {
  const live = normalizeSpoken(browser);
  const remote = normalizeSpoken(server);
  if (!remote) return live;
  if (!live) return remote;
  if (coversSpoken(live, remote)) return live;
  if (coversSpoken(remote, live)) return remote;
  return appendTranscript(live, remote);
}
